import { render } from "./setColor.vue?vue&type=template&id=2cb6ce8f&scoped=true"
import script from "./setColor.vue?vue&type=script&lang=js"
export * from "./setColor.vue?vue&type=script&lang=js"

import "./setColor.vue?vue&type=style&index=0&id=2cb6ce8f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cb6ce8f"

export default script